module.exports = __webpack_public_path__ + "files/238999bfe703df493f2bdd99026b6607.png";